import { closeMenu } from '../menu';
import { closeSearch } from '../header/search';

const eventHandler = () => {
  const el = document.querySelector('.js-page-overlay');
  if (el) {
    el.addEventListener('click', () => {
      closeMenu();
      closeSearch();
    });
  }
};

const pageOverlay = async () => eventHandler();

export default pageOverlay;
